/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OnboardingType {
  OPEN_ENROLLMENT = 'OPEN_ENROLLMENT',
  SPECIAL = 'SPECIAL',
}
